<template>
    <div v-if="marketingpipeline">
        <div v-if="headingloader">
            <Skeleton height="1rem" width="300px" class="my-3" />
            <Skeleton height="1rem" width="700px" class="mb-5" />

            <div class="d-flex align-items-center gap-3 mt-5">
                <Skeleton height="1.5rem" width="100px" class="my-3" />
                <Skeleton height="1.5rem" width="100px" class="my-3" />
                <Skeleton height="1.5rem" width="100px" class="my-3" />
                <Skeleton height="1.5rem" width="100px" class="my-3" />
            </div>
        </div>
        <b-row>
            <b-col lg="4" md="4" sm="6" cols="6" v-for="item in 10">
                <Skeleton height="9rem" width="100%" class="mt-5" />
            </b-col>
        </b-row>
    </div>
    <div v-if="!marketingpipeline">
        <div v-if="headingloader">
            <Skeleton height="1rem" width="300px" class="my-3" />
            <Skeleton height="1rem" width="700px" class="mb-5" />

            <div class="d-flex align-items-center gap-3 mt-5">
                <Skeleton height="2.5rem" width="250px" class="my-3" />
                <Skeleton height="2.5rem" width="250px" class="my-3" />
            </div>
        </div>
        <b-row>
            <b-col lg="4" md="4" sm="6" cols="6" v-for="item in 3">
                <Skeleton height="20rem" width="100%" class="mt-5" />
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue'

export default defineComponent({
    components: {
    },
    props: {
        headingloader: {
            type: Boolean,
            default: true
        },
        marketingpipeline: {
            type: Boolean,
            default: true
        },
    },
    setup() {


        return {

        }
    }

})
</script>

<style lang="scss" scoped></style>